module.exports = __webpack_public_path__ + "static/media/9_Search Filters.939ddacd.jpg";